import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Page, Card, DropZone, BlockStack, Text, Banner, Button, InlineStack,
} from '@shopify/polaris';
import DiffModal from './DiffModal';
import { api } from './apiClient';

export default function Upload() {
  const nav = useNavigate();
  const [xlsm, setXlsm] = useState(null);
  const [docx, setDocx] = useState(null);
  const [resp, setResp] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  async function submit() {
    if (!xlsm) return;
    setBusy(true); setErr(null);
    try {
      const r = await api.uploadFile(xlsm, docx);
      setResp(r);
    } catch (e) {
      setErr(e.message ?? 'Upload failed');
    } finally {
      setBusy(false);
    }
  }

  async function commit() {
    if (!resp) return;
    setBusy(true);
    try {
      await api.commitUpload(resp.upload_id);
      nav('/adidas-map');
    } catch (e) {
      setErr(e.message ?? 'Commit failed');
    } finally {
      setBusy(false);
    }
  }

  async function cancel() {
    if (!resp) return;
    setBusy(true);
    try {
      await api.cancelUpload(resp.upload_id);
      setResp(null);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Page title="Upload new MAP file" backAction={{ onAction: () => nav('/adidas-map') }}>
      {err && <Banner tone="critical">{err}</Banner>}
      <Card>
        <BlockStack gap="400">
          <Text as="p" variant="bodyMd">Drop the Adidas MAP xlsm (required): the spreadsheet is the source of truth. The policy docx is optional and only kept alongside it for reference; nothing is read from it.</Text>
          <DropZone
            accept=".xlsm,.docx"
            allowMultiple
            onDrop={(files) => {
              const x = files.find((f) => f.name.toLowerCase().endsWith('.xlsm')) ?? null;
              const d = files.find((f) => f.name.toLowerCase().endsWith('.docx')) ?? null;
              setXlsm(x); setDocx(d);
            }}
          >
            <DropZone.FileUpload />
          </DropZone>
          <BlockStack gap="100">
            <Text as="p" variant="bodySm">xlsm: {xlsm?.name ?? '—'}</Text>
            <Text as="p" variant="bodySm">docx: {docx?.name ?? '—'}</Text>
          </BlockStack>
          <InlineStack>
            <Button variant="primary" disabled={!xlsm} loading={busy} onClick={submit}>
              Parse and preview diff
            </Button>
          </InlineStack>
        </BlockStack>
      </Card>

      {resp && <DiffModal resp={resp} onCommit={commit} onCancel={cancel} busy={busy} />}
    </Page>
  );
}
